import type {
  DocumentoFiscal,
  ServicoTomado,
  CenarioApuracao,
  ComparativoComiteGestor,
  ResumoApuracaoPorCenario,
} from '@/lib/types/fiscal';

// Dados mockados para demonstração
export const documentosEntrada: DocumentoFiscal[] = [
  {
    id: '1',
    tipo: 'NFE',
    modelo: '55',
    numero: '000123',
    serie: '1',
    chaveAcesso: '35240112345678901234550010001230001234567890',
    dataEmissao: new Date('2025-01-15'),
    tipoOperacao: 'ENTRADA',
    cst: '000',
    cfop: '1102',
    descricaoCfop: 'Compra para comercialização',
    cClassTrib: '000001',
    descricaoClassTrib: '000001 - Tributação Padrão',
    valorTotal: 50000.0,
    baseCalculoIBS: 50000.0,
    valorIBS: 50.0,
    baseCalculoCBS: 50000.0,
    valorCBS: 450.0,
    aliquotaIBS: 0.001,
    aliquotaCBS: 0.009,
    impostosTradicionais: {
      baseCalculoICMS: 50000.0,
      aliquotaICMS: 0.18,
      valorICMS: 9000.0,
      baseCalculoIPI: 50000.0,
      aliquotaIPI: 0.05,
      valorIPI: 2500.0,
      baseCalculoPIS: 50000.0,
      aliquotaPIS: 0.0165,
      valorPIS: 825.0,
      baseCalculoCOFINS: 50000.0,
      aliquotaCOFINS: 0.076,
      valorCOFINS: 3800.0,
    },
    novasTags: {
      creditoPresumidoIBS: 0,
      creditoPresumidoCBS: 0,
      compraGovernamental: false,
      aliquotaIBSMunicipal: 0.0005,
      aliquotaIBSEstadual: 0.0005,
    },
    status: 'AUTORIZADO',
    emitente: {
      cnpj: '12.345.678/0001-90',
      razaoSocial: 'Fornecedor ABC Ltda',
      uf: 'SP',
    },
    destinatario: {
      cnpj: '98.765.432/0001-10',
      razaoSocial: 'Minha Empresa Ltda',
      uf: 'SP',
    },
    itens: [
      {
        id: '1-1',
        numeroItem: 1,
        codigoProduto: 'PROD001',
        descricao: 'Produto A',
        ncm: '84714100',
        cfop: '1102',
        cst: '000',
        cClassTrib: '000001',
        quantidade: 100,
        valorUnitario: 500.0,
        valorTotal: 50000.0,
        baseCalculoIBS: 50000.0,
        valorIBS: 50.0,
        aliquotaIBS: 0.001,
        baseCalculoCBS: 50000.0,
        valorCBS: 450.0,
        aliquotaCBS: 0.009,
        impostosTradicionais: {
          baseCalculoICMS: 50000.0,
          aliquotaICMS: 0.18,
          valorICMS: 9000.0,
          baseCalculoIPI: 50000.0,
          aliquotaIPI: 0.05,
          valorIPI: 2500.0,
          baseCalculoPIS: 50000.0,
          aliquotaPIS: 0.0165,
          valorPIS: 825.0,
          baseCalculoCOFINS: 50000.0,
          aliquotaCOFINS: 0.076,
          valorCOFINS: 3800.0,
        },
      },
    ],
  },
  {
    id: '2',
    tipo: 'NFE',
    modelo: '55',
    numero: '000124',
    serie: '1',
    chaveAcesso: '35240112345678901234550010001240001234567891',
    dataEmissao: new Date('2025-01-16'),
    tipoOperacao: 'ENTRADA',
    cst: '000',
    cfop: '2102',
    descricaoCfop: 'Compra para comercialização - Interestadual',
    cClassTrib: '000001',
    descricaoClassTrib: '000001 - Tributação Padrão',
    valorTotal: 75000.0,
    baseCalculoIBS: 75000.0,
    valorIBS: 75.0,
    baseCalculoCBS: 75000.0,
    valorCBS: 675.0,
    aliquotaIBS: 0.001,
    aliquotaCBS: 0.009,
    impostosTradicionais: {
      baseCalculoICMS: 75000.0,
      aliquotaICMS: 0.12,
      valorICMS: 9000.0,
      baseCalculoIPI: 75000.0,
      aliquotaIPI: 0.05,
      valorIPI: 3750.0,
      baseCalculoPIS: 75000.0,
      aliquotaPIS: 0.0165,
      valorPIS: 1237.5,
      baseCalculoCOFINS: 75000.0,
      aliquotaCOFINS: 0.076,
      valorCOFINS: 5700.0,
    },
    novasTags: {
      creditoPresumidoIBS: 0,
      creditoPresumidoCBS: 0,
      compraGovernamental: false,
      aliquotaIBSMunicipal: 0.0005,
      aliquotaIBSEstadual: 0.0005,
    },
    status: 'AUTORIZADO',
    emitente: {
      cnpj: '23.456.789/0001-01',
      razaoSocial: 'Fornecedor XYZ S.A.',
      uf: 'RJ',
    },
    destinatario: {
      cnpj: '98.765.432/0001-10',
      razaoSocial: 'Minha Empresa Ltda',
      uf: 'SP',
    },
    itens: [
      {
        id: '2-1',
        numeroItem: 1,
        codigoProduto: 'PROD002',
        descricao: 'Produto B',
        ncm: '84715000',
        cfop: '2102',
        cst: '000',
        cClassTrib: '000001',
        quantidade: 150,
        valorUnitario: 500.0,
        valorTotal: 75000.0,
        baseCalculoIBS: 75000.0,
        valorIBS: 75.0,
        aliquotaIBS: 0.001,
        baseCalculoCBS: 75000.0,
        valorCBS: 675.0,
        aliquotaCBS: 0.009,
        impostosTradicionais: {
          baseCalculoICMS: 75000.0,
          aliquotaICMS: 0.12,
          valorICMS: 9000.0,
          baseCalculoIPI: 75000.0,
          aliquotaIPI: 0.05,
          valorIPI: 3750.0,
          baseCalculoPIS: 75000.0,
          aliquotaPIS: 0.0165,
          valorPIS: 1237.5,
          baseCalculoCOFINS: 75000.0,
          aliquotaCOFINS: 0.076,
          valorCOFINS: 5700.0,
        },
      },
    ],
  },
  {
    id: '3',
    tipo: 'NFCOM',
    modelo: '66',
    numero: '000001',
    serie: '1',
    chaveAcesso: '35240112345678901234550010000010001234567892',
    dataEmissao: new Date('2025-01-10'),
    tipoOperacao: 'ENTRADA',
    cst: '000',
    cfop: '1303',
    descricaoCfop: 'Aquisição de serviço de comunicação',
    cClassTrib: '000001',
    descricaoClassTrib: '000001 - Tributação Padrão',
    valorTotal: 5000.0,
    baseCalculoIBS: 5000.0,
    valorIBS: 5.0,
    baseCalculoCBS: 5000.0,
    valorCBS: 45.0,
    aliquotaIBS: 0.001,
    aliquotaCBS: 0.009,
    impostosTradicionais: {
      baseCalculoICMS: 5000.0,
      aliquotaICMS: 0.25,
      valorICMS: 1250.0,
      baseCalculoIPI: 0,
      aliquotaIPI: 0,
      valorIPI: 0,
      baseCalculoPIS: 5000.0,
      aliquotaPIS: 0.0165,
      valorPIS: 82.5,
      baseCalculoCOFINS: 5000.0,
      aliquotaCOFINS: 0.076,
      valorCOFINS: 380.0,
    },
    novasTags: {
      creditoPresumidoIBS: 0,
      creditoPresumidoCBS: 0,
      compraGovernamental: false,
      aliquotaIBSMunicipal: 0.0005,
      aliquotaIBSEstadual: 0.0005,
    },
    status: 'AUTORIZADO',
    emitente: {
      cnpj: '34.567.890/0001-12',
      razaoSocial: 'Telecom Brasil S.A.',
      uf: 'SP',
    },
    destinatario: {
      cnpj: '98.765.432/0001-10',
      razaoSocial: 'Minha Empresa Ltda',
      uf: 'SP',
    },
    itens: [],
  },
  {
    id: '4',
    tipo: 'NF3E',
    modelo: '67',
    numero: '000002',
    serie: '1',
    chaveAcesso: '35240112345678901234550010000020001234567893',
    dataEmissao: new Date('2025-01-12'),
    tipoOperacao: 'ENTRADA',
    cst: '000',
    cfop: '1253',
    descricaoCfop: 'Aquisição de energia elétrica',
    cClassTrib: '000001',
    descricaoClassTrib: '000001 - Tributação Padrão',
    valorTotal: 8000.0,
    baseCalculoIBS: 8000.0,
    valorIBS: 8.0,
    baseCalculoCBS: 8000.0,
    valorCBS: 72.0,
    aliquotaIBS: 0.001,
    aliquotaCBS: 0.009,
    impostosTradicionais: {
      baseCalculoICMS: 8000.0,
      aliquotaICMS: 0.25,
      valorICMS: 2000.0,
      baseCalculoIPI: 0,
      aliquotaIPI: 0,
      valorIPI: 0,
      baseCalculoPIS: 8000.0,
      aliquotaPIS: 0.0165,
      valorPIS: 132.0,
      baseCalculoCOFINS: 8000.0,
      aliquotaCOFINS: 0.076,
      valorCOFINS: 608.0,
    },
    novasTags: {
      creditoPresumidoIBS: 0,
      creditoPresumidoCBS: 0,
      compraGovernamental: false,
      aliquotaIBSMunicipal: 0.0005,
      aliquotaIBSEstadual: 0.0005,
    },
    status: 'AUTORIZADO',
    emitente: {
      cnpj: '45.678.901/0001-23',
      razaoSocial: 'Energia SP S.A.',
      uf: 'SP',
    },
    destinatario: {
      cnpj: '98.765.432/0001-10',
      razaoSocial: 'Minha Empresa Ltda',
      uf: 'SP',
    },
    itens: [],
  },
  {
    id: '5',
    tipo: 'CTE',
    modelo: '57',
    numero: '000100',
    serie: '1',
    chaveAcesso: '35240156789012345678570010001000001234567894',
    dataEmissao: new Date('2025-01-18'),
    tipoOperacao: 'ENTRADA',
    cst: '000',
    cfop: '1351',
    descricaoCfop: 'Aquisição de serviço de transporte',
    cClassTrib: '000001',
    descricaoClassTrib: '000001 - Tributação Padrão',
    valorTotal: 3500.0,
    baseCalculoIBS: 3500.0,
    valorIBS: 3.5,
    baseCalculoCBS: 3500.0,
    valorCBS: 31.5,
    aliquotaIBS: 0.001,
    aliquotaCBS: 0.009,
    impostosTradicionais: {
      baseCalculoICMS: 3500.0,
      aliquotaICMS: 0.12,
      valorICMS: 420.0,
      baseCalculoIPI: 0,
      aliquotaIPI: 0,
      valorIPI: 0,
      baseCalculoPIS: 3500.0,
      aliquotaPIS: 0.0165,
      valorPIS: 57.75,
      baseCalculoCOFINS: 3500.0,
      aliquotaCOFINS: 0.076,
      valorCOFINS: 266.0,
    },
    novasTags: {
      creditoPresumidoIBS: 0,
      creditoPresumidoCBS: 0,
      compraGovernamental: false,
      aliquotaIBSMunicipal: 0.0005,
      aliquotaIBSEstadual: 0.0005,
    },
    status: 'AUTORIZADO',
    emitente: {
      cnpj: '56.789.012/0001-34',
      razaoSocial: 'Transportadora Rápida Ltda',
      uf: 'SP',
    },
    destinatario: {
      cnpj: '98.765.432/0001-10',
      razaoSocial: 'Minha Empresa Ltda',
      uf: 'SP',
    },
    itens: [],
  },
  {
    id: '6',
    tipo: 'CTE',
    modelo: '57',
    numero: '000101',
    serie: '1',
    chaveAcesso: '31240167890123456789570010001010001234567895',
    dataEmissao: new Date('2025-01-22'),
    tipoOperacao: 'ENTRADA',
    cst: '000',
    cfop: '2351',
    descricaoCfop: 'Aquisição de serviço de transporte - Interestadual',
    cClassTrib: '000001',
    descricaoClassTrib: '000001 - Tributação Padrão',
    valorTotal: 4200.0,
    baseCalculoIBS: 4200.0,
    valorIBS: 4.2,
    baseCalculoCBS: 4200.0,
    valorCBS: 37.8,
    aliquotaIBS: 0.001,
    aliquotaCBS: 0.009,
    impostosTradicionais: {
      baseCalculoICMS: 4200.0,
      aliquotaICMS: 0.12,
      valorICMS: 504.0,
      baseCalculoIPI: 0,
      aliquotaIPI: 0,
      valorIPI: 0,
      baseCalculoPIS: 4200.0,
      aliquotaPIS: 0.0165,
      valorPIS: 69.3,
      baseCalculoCOFINS: 4200.0,
      aliquotaCOFINS: 0.076,
      valorCOFINS: 319.2,
    },
    novasTags: {
      creditoPresumidoIBS: 0,
      creditoPresumidoCBS: 0,
      compraGovernamental: false,
      aliquotaIBSMunicipal: 0.0005,
      aliquotaIBSEstadual: 0.0005,
    },
    status: 'AUTORIZADO',
    emitente: {
      cnpj: '67.890.123/0001-45',
      razaoSocial: 'Logística Nacional S.A.',
      uf: 'MG',
    },
    destinatario: {
      cnpj: '98.765.432/0001-10',
      razaoSocial: 'Minha Empresa Ltda',
      uf: 'SP',
    },
    itens: [],
  },
];

export const documentosSaida: DocumentoFiscal[] = [
  {
    id: '5',
    tipo: 'NFE',
    modelo: '55',
    numero: '000456',
    serie: '1',
    chaveAcesso: '35240198765432001010550010004560001234567894',
    dataEmissao: new Date('2025-01-20'),
    tipoOperacao: 'SAIDA',
    cst: '000',
    cfop: '5102',
    descricaoCfop: 'Venda de mercadoria',
    cClassTrib: '000001',
    descricaoClassTrib: '000001 - Tributação Padrão',
    valorTotal: 120000.0,
    baseCalculoIBS: 120000.0,
    valorIBS: 120.0,
    baseCalculoCBS: 120000.0,
    valorCBS: 1080.0,
    aliquotaIBS: 0.001,
    aliquotaCBS: 0.009,
    impostosTradicionais: {
      baseCalculoICMS: 120000.0,
      aliquotaICMS: 0.18,
      valorICMS: 21600.0,
      baseCalculoIPI: 120000.0,
      aliquotaIPI: 0.05,
      valorIPI: 6000.0,
      baseCalculoPIS: 120000.0,
      aliquotaPIS: 0.0165,
      valorPIS: 1980.0,
      baseCalculoCOFINS: 120000.0,
      aliquotaCOFINS: 0.076,
      valorCOFINS: 9120.0,
    },
    novasTags: {
      creditoPresumidoIBS: 0,
      creditoPresumidoCBS: 0,
      compraGovernamental: false,
      aliquotaIBSMunicipal: 0.0005,
      aliquotaIBSEstadual: 0.0005,
    },
    status: 'AUTORIZADO',
    emitente: {
      cnpj: '98.765.432/0001-10',
      razaoSocial: 'Minha Empresa Ltda',
      uf: 'SP',
    },
    destinatario: {
      cnpj: '11.222.333/0001-44',
      razaoSocial: 'Cliente Final Ltda',
      uf: 'SP',
    },
    itens: [
      {
        id: '5-1',
        numeroItem: 1,
        codigoProduto: 'PROD001',
        descricao: 'Produto A',
        ncm: '84714100',
        cfop: '5102',
        cst: '000',
        cClassTrib: '000001',
        quantidade: 200,
        valorUnitario: 600.0,
        valorTotal: 120000.0,
        baseCalculoIBS: 120000.0,
        valorIBS: 120.0,
        baseCalculoCBS: 120000.0,
        valorCBS: 1080.0,
        aliquotaIBS: 0.001,
        aliquotaCBS: 0.009,
        impostosTradicionais: {
          baseCalculoICMS: 120000.0,
          aliquotaICMS: 0.18,
          valorICMS: 21600.0,
          baseCalculoIPI: 120000.0,
          aliquotaIPI: 0.05,
          valorIPI: 6000.0,
          baseCalculoPIS: 120000.0,
          aliquotaPIS: 0.0165,
          valorPIS: 1980.0,
          baseCalculoCOFINS: 120000.0,
          aliquotaCOFINS: 0.076,
          valorCOFINS: 9120.0,
        },
      },
    ],
  },
  {
    id: '6',
    tipo: 'NFE',
    modelo: '55',
    numero: '000457',
    serie: '1',
    chaveAcesso: '35240198765432001010550010004570001234567895',
    dataEmissao: new Date('2025-01-22'),
    tipoOperacao: 'SAIDA',
    cst: '000',
    cfop: '6102',
    descricaoCfop: 'Venda de mercadoria - Interestadual',
    cClassTrib: '000001',
    descricaoClassTrib: '000001 - Tributação Padrão',
    valorTotal: 95000.0,
    baseCalculoIBS: 95000.0,
    valorIBS: 95.0,
    baseCalculoCBS: 95000.0,
    valorCBS: 855.0,
    aliquotaIBS: 0.001,
    aliquotaCBS: 0.009,
    impostosTradicionais: {
      baseCalculoICMS: 95000.0,
      aliquotaICMS: 0.12,
      valorICMS: 11400.0,
      baseCalculoIPI: 95000.0,
      aliquotaIPI: 0.05,
      valorIPI: 4750.0,
      baseCalculoPIS: 95000.0,
      aliquotaPIS: 0.0165,
      valorPIS: 1567.5,
      baseCalculoCOFINS: 95000.0,
      aliquotaCOFINS: 0.076,
      valorCOFINS: 7220.0,
    },
    novasTags: {
      creditoPresumidoIBS: 0,
      creditoPresumidoCBS: 0,
      compraGovernamental: false,
      aliquotaIBSMunicipal: 0.0005,
      aliquotaIBSEstadual: 0.0005,
    },
    status: 'AUTORIZADO',
    emitente: {
      cnpj: '98.765.432/0001-10',
      razaoSocial: 'Minha Empresa Ltda',
      uf: 'SP',
    },
    destinatario: {
      cnpj: '22.333.444/0001-55',
      razaoSocial: 'Cliente RJ Comércio',
      uf: 'RJ',
    },
    itens: [
      {
        id: '6-1',
        numeroItem: 1,
        codigoProduto: 'PROD002',
        descricao: 'Produto B',
        ncm: '84715000',
        cfop: '6102',
        cst: '000',
        cClassTrib: '000001',
        quantidade: 190,
        valorUnitario: 500.0,
        valorTotal: 95000.0,
        baseCalculoIBS: 95000.0,
        valorIBS: 95.0,
        baseCalculoCBS: 95000.0,
        valorCBS: 855.0,
        aliquotaIBS: 0.001,
        aliquotaCBS: 0.009,
        impostosTradicionais: {
          baseCalculoICMS: 95000.0,
          aliquotaICMS: 0.12,
          valorICMS: 11400.0,
          baseCalculoIPI: 95000.0,
          aliquotaIPI: 0.05,
          valorIPI: 4750.0,
          baseCalculoPIS: 95000.0,
          aliquotaPIS: 0.0165,
          valorPIS: 1567.5,
          baseCalculoCOFINS: 95000.0,
          aliquotaCOFINS: 0.076,
          valorCOFINS: 7220.0,
        },
      },
    ],
  },
  {
    id: '7',
    tipo: 'NFE',
    modelo: '65',
    numero: '000010',
    serie: '1',
    chaveAcesso: '35240198765432001010550010000100001234567896',
    dataEmissao: new Date('2025-01-25'),
    tipoOperacao: 'SAIDA',
    cst: '000',
    cfop: '5102',
    descricaoCfop: 'Venda ao consumidor final',
    cClassTrib: '000001',
    descricaoClassTrib: '000001 - Tributação Padrão',
    valorTotal: 25000.0,
    baseCalculoIBS: 25000.0,
    valorIBS: 25.0,
    baseCalculoCBS: 25000.0,
    valorCBS: 225.0,
    aliquotaIBS: 0.001,
    aliquotaCBS: 0.009,
    impostosTradicionais: {
      baseCalculoICMS: 25000.0,
      aliquotaICMS: 0.18,
      valorICMS: 4500.0,
      baseCalculoIPI: 0,
      aliquotaIPI: 0,
      valorIPI: 0,
      baseCalculoPIS: 25000.0,
      aliquotaPIS: 0.0165,
      valorPIS: 412.5,
      baseCalculoCOFINS: 25000.0,
      aliquotaCOFINS: 0.076,
      valorCOFINS: 1900.0,
    },
    novasTags: {
      creditoPresumidoIBS: 0,
      creditoPresumidoCBS: 0,
      compraGovernamental: false,
      aliquotaIBSMunicipal: 0.0005,
      aliquotaIBSEstadual: 0.0005,
    },
    status: 'AUTORIZADO',
    emitente: {
      cnpj: '98.765.432/0001-10',
      razaoSocial: 'Minha Empresa Ltda',
      uf: 'SP',
    },
    destinatario: {
      cnpj: '33.444.555/0001-66',
      razaoSocial: 'Consumidor Final',
      uf: 'SP',
    },
    itens: [],
  },
];

export const servicosTomados: ServicoTomado[] = [
  {
    id: 's1',
    numeroDocumento: 'NFS-e 12345',
    dataEmissao: new Date('2025-01-08'),
    prestador: {
      cnpj: '55.666.777/0001-88',
      razaoSocial: 'Consultoria Tech Ltda',
    },
    descricaoServico: 'Consultoria em TI',
    valorServico: 15000.0,
    baseCalculoIBS: 15000.0,
    valorIBSCredito: 375.0,
    baseCalculoCBS: 15000.0,
    valorCBSCredito: 1275.0,
    direitoCredito: true,
    motivoCredito: 'Serviço vinculado à atividade empresarial',
  },
  {
    id: 's2',
    numeroDocumento: 'NFS-e 12346',
    dataEmissao: new Date('2025-01-14'),
    prestador: {
      cnpj: '66.777.888/0001-99',
      razaoSocial: 'Contabilidade Exata S.S.',
    },
    descricaoServico: 'Serviços contábeis',
    valorServico: 8000.0,
    baseCalculoIBS: 8000.0,
    valorIBSCredito: 200.0,
    baseCalculoCBS: 8000.0,
    valorCBSCredito: 680.0,
    direitoCredito: true,
    motivoCredito: 'Serviço essencial à operação',
  },
  {
    id: 's3',
    numeroDocumento: 'NFS-e 12347',
    dataEmissao: new Date('2025-01-18'),
    prestador: {
      cnpj: '77.888.999/0001-00',
      razaoSocial: 'Marketing Digital Pro',
    },
    descricaoServico: 'Serviços de marketing',
    valorServico: 12000.0,
    baseCalculoIBS: 12000.0,
    valorIBSCredito: 300.0,
    baseCalculoCBS: 12000.0,
    valorCBSCredito: 1020.0,
    direitoCredito: true,
    motivoCredito: 'Despesa operacional dedutível',
  },
];

export const cenariosApuracao: CenarioApuracao[] = [
  {
    id: 'c1',
    nome: 'Cenário 1 - Apuração Normal',
    descricao: 'Apuração padrão com todos os documentos',
    periodo: {
      inicio: new Date('2025-01-01'),
      fim: new Date('2025-01-31'),
    },
    totalDebitos: {
      ibs: 6000.0,
      cbs: 20400.0,
    },
    totalCreditos: {
      ibs: 4325.0,
      cbs: 13005.0,
    },
    saldoApurado: {
      ibs: 1675.0,
      cbs: 7395.0,
    },
    apuracaoPorCFOP: [],
  },
  {
    id: 'c2',
    nome: 'Cenário 2 - Com Ajustes',
    descricao: 'Apuração com ajustes de créditos extemporâneos',
    periodo: {
      inicio: new Date('2025-01-01'),
      fim: new Date('2025-01-31'),
    },
    totalDebitos: {
      ibs: 6000.0,
      cbs: 20400.0,
    },
    totalCreditos: {
      ibs: 4825.0,
      cbs: 14255.0,
    },
    saldoApurado: {
      ibs: 1175.0,
      cbs: 6145.0,
    },
    apuracaoPorCFOP: [],
  },
  {
    id: 'c3',
    nome: 'Cenário 3 - Regime Especial',
    descricao: 'Apuração considerando benefícios fiscais',
    periodo: {
      inicio: new Date('2025-01-01'),
      fim: new Date('2025-01-31'),
    },
    totalDebitos: {
      ibs: 5400.0,
      cbs: 18360.0,
    },
    totalCreditos: {
      ibs: 4325.0,
      cbs: 13005.0,
    },
    saldoApurado: {
      ibs: 1075.0,
      cbs: 5355.0,
    },
    apuracaoPorCFOP: [],
  },
];

export const comparativoComiteGestor: ComparativoComiteGestor = {
  periodo: 'Janeiro/2025',
  valorApuradoEmpresa: {
    ibs: 1675.0,
    cbs: 7395.0,
    total: 9070.0,
  },
  valorComiteGestor: {
    ibs: 1650.0,
    cbs: 7420.0,
    total: 9070.0,
  },
  divergencia: {
    ibs: 25.0,
    cbs: -25.0,
    total: 0.0,
    percentual: 0.28,
  },
  status: 'CONFORME',
};

export const apuracaoEntradas: ResumoApuracaoPorCenario[] = [
  {
    cenario: 'TRIBUTADO',
    descricao: 'Operações Tributadas Integralmente',
    itens: [
      {
        cfop: '1101',
        cst: '000',
        cClassTrib: '000001',
        descricaoCfop: 'Compra de matéria-prima X (Padrão)',
        descricaoClassTrib: '000001 - Tributação Padrão',
        valorOperacao: 1000.0,
        baseCalculoIBS: 1000.0,
        aliquotaIBS: 0.001,
        valorIBS: 1.0,
        baseCalculoCBS: 1000.0,
        aliquotaCBS: 0.009,
        valorCBS: 9.0,
        quantidadeDocumentos: 1,
        documentos: [],
      },
      {
        cfop: '1102',
        cst: '000',
        cClassTrib: '000001',
        descricaoCfop: 'Compra de produto acabado Y (Padrão)',
        descricaoClassTrib: '000001 - Tributação Padrão',
        valorOperacao: 1500.0,
        baseCalculoIBS: 1500.0,
        aliquotaIBS: 0.001,
        valorIBS: 1.5,
        baseCalculoCBS: 1500.0,
        aliquotaCBS: 0.009,
        valorCBS: 13.5,
        quantidadeDocumentos: 1,
        documentos: [],
      },
      {
        cfop: '1202',
        cst: '000',
        cClassTrib: '000001',
        descricaoCfop: 'Devolução de venda (Crédito - Padrão)',
        descricaoClassTrib: '000001 - Tributação Padrão',
        valorOperacao: 300.0,
        baseCalculoIBS: 300.0,
        aliquotaIBS: 0.001,
        valorIBS: 0.3,
        baseCalculoCBS: 300.0,
        aliquotaCBS: 0.009,
        valorCBS: 2.7,
        quantidadeDocumentos: 1,
        documentos: [],
      },
    ],
    totais: {
      valorOperacao: 2800.0,
      baseCalculoIBS: 2800.0,
      valorIBS: 2.8,
      baseCalculoCBS: 2800.0,
      valorCBS: 25.2,
    },
  },
  {
    cenario: 'NAO_INCIDENCIA',
    descricao: 'Operações com Não Incidência',
    itens: [
      {
        cfop: '1556',
        cst: '410',
        cClassTrib: '999999',
        descricaoCfop: 'Material de escritório (Não Incidência)',
        descricaoClassTrib: '999999 - Não Incidência',
        valorOperacao: 200.0,
        baseCalculoIBS: 0.0,
        aliquotaIBS: 0.0,
        valorIBS: 0.0,
        baseCalculoCBS: 0.0,
        aliquotaCBS: 0.0,
        valorCBS: 0.0,
        quantidadeDocumentos: 1,
        documentos: [],
      },
    ],
    totais: {
      valorOperacao: 200.0,
      baseCalculoIBS: 0.0,
      valorIBS: 0.0,
      baseCalculoCBS: 0.0,
      valorCBS: 0.0,
    },
  },
  {
    cenario: 'ALIQUOTA_ZERO',
    descricao: 'Operações com Alíquota Zero',
    itens: [
      {
        cfop: '1403',
        cst: '200',
        cClassTrib: '200001',
        descricaoCfop: 'Compra de insumo agrícola (Alíquota Zero)',
        descricaoClassTrib: '200001 - Alíquota Reduzida',
        valorOperacao: 500.0,
        baseCalculoIBS: 0.0,
        aliquotaIBS: 0.0,
        valorIBS: 0.0,
        baseCalculoCBS: 0.0,
        aliquotaCBS: 0.0,
        valorCBS: 0.0,
        quantidadeDocumentos: 1,
        documentos: [],
      },
    ],
    totais: {
      valorOperacao: 500.0,
      baseCalculoIBS: 0.0,
      valorIBS: 0.0,
      baseCalculoCBS: 0.0,
      valorCBS: 0.0,
    },
  },
  {
    cenario: 'REDUZIDA',
    descricao: 'Operações com Alíquota Reduzida',
    itens: [
      {
        cfop: '1303',
        cst: '200',
        cClassTrib: '011002',
        descricaoCfop: 'Aquisição de serviço de saúde (Reduzida 60%)',
        descricaoClassTrib: '011002 - Planos de assistência à saúde',
        valorOperacao: 400.0,
        baseCalculoIBS: 400.0,
        aliquotaIBS: 0.0004,
        valorIBS: 0.16,
        baseCalculoCBS: 400.0,
        aliquotaCBS: 0.0036,
        valorCBS: 1.44,
        quantidadeDocumentos: 1,
        documentos: [],
      },
    ],
    totais: {
      valorOperacao: 400.0,
      baseCalculoIBS: 400.0,
      valorIBS: 0.16,
      baseCalculoCBS: 400.0,
      valorCBS: 1.44,
    },
  },
];

export const apuracaoSaidas: ResumoApuracaoPorCenario[] = [
  {
    cenario: 'TRIBUTADO',
    descricao: 'Operações Tributadas Integralmente',
    itens: [
      {
        cfop: '5101',
        cst: '000',
        cClassTrib: '000001',
        descricaoCfop: 'Venda de produção do estabelecimento',
        descricaoClassTrib: '000001 - Tributação Padrão',
        valorOperacao: 5000.0,
        baseCalculoIBS: 5000.0,
        aliquotaIBS: 0.001,
        valorIBS: 5.0,
        baseCalculoCBS: 5000.0,
        aliquotaCBS: 0.009,
        valorCBS: 45.0,
        quantidadeDocumentos: 3,
        documentos: [],
      },
      {
        cfop: '5102',
        cst: '000',
        cClassTrib: '000001',
        descricaoCfop: 'Venda de mercadoria adquirida',
        descricaoClassTrib: '000001 - Tributação Padrão',
        valorOperacao: 8500.0,
        baseCalculoIBS: 8500.0,
        aliquotaIBS: 0.001,
        valorIBS: 8.5,
        baseCalculoCBS: 8500.0,
        aliquotaCBS: 0.009,
        valorCBS: 76.5,
        quantidadeDocumentos: 5,
        documentos: [],
      },
    ],
    totais: {
      valorOperacao: 13500.0,
      baseCalculoIBS: 13500.0,
      valorIBS: 13.5,
      baseCalculoCBS: 13500.0,
      valorCBS: 121.5,
    },
  },
  {
    cenario: 'REDUZIDA',
    descricao: 'Operações com Alíquota Reduzida',
    itens: [
      {
        cfop: '5405',
        cst: '200',
        cClassTrib: '200003',
        descricaoCfop: 'Venda de produtos alimentícios (Reduzida 60%)',
        descricaoClassTrib: '200003 - Vendas de produtos destinados à alimentação humana',
        valorOperacao: 3200.0,
        baseCalculoIBS: 3200.0,
        aliquotaIBS: 0.0004,
        valorIBS: 1.28,
        baseCalculoCBS: 3200.0,
        aliquotaCBS: 0.0036,
        valorCBS: 11.52,
        quantidadeDocumentos: 2,
        documentos: [],
      },
    ],
    totais: {
      valorOperacao: 3200.0,
      baseCalculoIBS: 3200.0,
      valorIBS: 1.28,
      baseCalculoCBS: 3200.0,
      valorCBS: 11.52,
    },
  },
  {
    cenario: 'ISENCAO',
    descricao: 'Operações com Isenção',
    itens: [
      {
        cfop: '5656',
        cst: '400',
        cClassTrib: '400001',
        descricaoCfop: 'Venda de livros e periódicos (Isenção)',
        descricaoClassTrib: '400001 - Isenção',
        valorOperacao: 1200.0,
        baseCalculoIBS: 0.0,
        aliquotaIBS: 0.0,
        valorIBS: 0.0,
        baseCalculoCBS: 0.0,
        aliquotaCBS: 0.0,
        valorCBS: 0.0,
        quantidadeDocumentos: 1,
        documentos: [],
      },
    ],
    totais: {
      valorOperacao: 1200.0,
      baseCalculoIBS: 0.0,
      valorIBS: 0.0,
      baseCalculoCBS: 0.0,
      valorCBS: 0.0,
    },
  },
];

export const creditosComiteGestor = {
  totalCreditosDeclarados: {
    ibs: 2.96,
    cbs: 26.64,
  },
  creditosAprovados: {
    ibs: 2.5,
    cbs: 22.5,
  },
  creditosGlosados: {
    ibs: 0.46,
    cbs: 4.14,
  },
  detalhamento: [
    {
      cfop: '1101',
      cst: '000',
      cClassTrib: '000001',
      fornecedor: 'Fornecedor A Ltda',
      cnpj: '12.345.678/0001-90',
      valorOperacao: 1000.0,
      valorIBS: 1.0,
      valorCBS: 9.0,
      pagamentoConfirmado: true,
      dataPagamento: new Date('2025-01-20'),
      statusComite: 'APROVADO' as const,
    },
    {
      cfop: '1102',
      cst: '000',
      cClassTrib: '000001',
      fornecedor: 'Fornecedor B S.A.',
      cnpj: '23.456.789/0001-01',
      valorOperacao: 1500.0,
      valorIBS: 1.5,
      valorCBS: 13.5,
      pagamentoConfirmado: true,
      dataPagamento: new Date('2025-01-25'),
      statusComite: 'APROVADO' as const,
    },
    {
      cfop: '1202',
      cst: '000',
      cClassTrib: '000001',
      fornecedor: 'Cliente Devolução Ltda',
      cnpj: '34.567.890/0001-12',
      valorOperacao: 300.0,
      valorIBS: 0.3,
      valorCBS: 2.7,
      pagamentoConfirmado: false,
      dataPagamento: null,
      statusComite: 'GLOSADO' as const,
      motivoGlosa: 'Pagamento não confirmado',
    },
    {
      cfop: '1303',
      cst: '200',
      cClassTrib: '011002',
      fornecedor: 'Serviços Saúde S.A.',
      cnpj: '45.678.901/0001-23',
      valorOperacao: 400.0,
      valorIBS: 0.16,
      valorCBS: 1.44,
      pagamentoConfirmado: false,
      dataPagamento: null,
      statusComite: 'GLOSADO' as const,
      motivoGlosa: 'Aguardando comprovação de pagamento',
    },
  ],
};

export const fornecedoresMock = [
  {
    id: 'f1',
    cnpj: '12.345.678/0001-90',
    razaoSocial: 'Fornecedor ABC Ltda',
    nomeFantasia: 'ABC Distribuidora',
    uf: 'SP',
    municipio: 'São Paulo',
    situacaoCadastral: 'ATIVA' as const,
    dataAbertura: new Date('2010-05-15'),
    regularidadeFiscal: {
      receitaFederal: {
        status: 'REGULAR' as const,
        dataConsulta: new Date('2025-01-28'),
      },
      certidaoNegativa: {
        status: 'VALIDA' as const,
        dataEmissao: new Date('2024-12-15'),
        dataValidade: new Date('2025-06-15'),
        numero: 'CN-2024-123456',
      },
      fgts: {
        status: 'REGULAR' as const,
        dataConsulta: new Date('2025-01-28'),
      },
      trabalhista: {
        status: 'REGULAR' as const,
        dataConsulta: new Date('2025-01-28'),
      },
    },
    inadimplencia: {
      status: 'ADIMPLENTE' as const,
    },
    validacaoCredito: {
      aprovado: true,
      dataValidacao: new Date('2025-01-28'),
      validadoPor: 'Sistema Automático',
    },
    estatisticas: {
      totalCompras: 125000.0,
      totalCreditoIBS: 125.0,
      totalCreditoCBS: 1125.0,
      quantidadeNotas: 15,
    },
  },
  {
    id: 'f2',
    cnpj: '23.456.789/0001-01',
    razaoSocial: 'Fornecedor XYZ S.A.',
    nomeFantasia: 'XYZ Comércio',
    uf: 'RJ',
    municipio: 'Rio de Janeiro',
    situacaoCadastral: 'ATIVA' as const,
    dataAbertura: new Date('2015-08-20'),
    regularidadeFiscal: {
      receitaFederal: {
        status: 'REGULAR' as const,
        dataConsulta: new Date('2025-01-28'),
      },
      certidaoNegativa: {
        status: 'VALIDA' as const,
        dataEmissao: new Date('2025-01-10'),
        dataValidade: new Date('2025-07-10'),
        numero: 'CN-2025-789012',
      },
      fgts: {
        status: 'REGULAR' as const,
        dataConsulta: new Date('2025-01-28'),
      },
      trabalhista: {
        status: 'REGULAR' as const,
        dataConsulta: new Date('2025-01-28'),
      },
    },
    inadimplencia: {
      status: 'ADIMPLENTE' as const,
    },
    validacaoCredito: {
      aprovado: true,
      dataValidacao: new Date('2025-01-28'),
      validadoPor: 'Sistema Automático',
    },
    estatisticas: {
      totalCompras: 95000.0,
      totalCreditoIBS: 95.0,
      totalCreditoCBS: 855.0,
      quantidadeNotas: 12,
    },
  },
  {
    id: 'f3',
    cnpj: '34.567.890/0001-12',
    razaoSocial: 'Fornecedor DEF Ltda',
    nomeFantasia: 'DEF Materiais',
    uf: 'MG',
    municipio: 'Belo Horizonte',
    situacaoCadastral: 'ATIVA' as const,
    dataAbertura: new Date('2018-03-10'),
    regularidadeFiscal: {
      receitaFederal: {
        status: 'IRREGULAR' as const,
        dataConsulta: new Date('2025-01-28'),
        motivoIrregularidade: 'Pendências tributárias',
      },
      certidaoNegativa: {
        status: 'VENCIDA' as const,
        dataEmissao: new Date('2024-06-15'),
        dataValidade: new Date('2024-12-15'),
        numero: 'CN-2024-345678',
      },
      fgts: {
        status: 'IRREGULAR' as const,
        dataConsulta: new Date('2025-01-28'),
      },
      trabalhista: {
        status: 'REGULAR' as const,
        dataConsulta: new Date('2025-01-28'),
      },
    },
    inadimplencia: {
      status: 'INADIMPLENTE' as const,
      valorTotal: 45000.0,
      quantidadeDebitos: 3,
      detalhes: [
        {
          tipo: 'ICMS',
          valor: 25000.0,
          dataVencimento: new Date('2024-11-30'),
        },
        {
          tipo: 'PIS/COFINS',
          valor: 15000.0,
          dataVencimento: new Date('2024-12-15'),
        },
        {
          tipo: 'FGTS',
          valor: 5000.0,
          dataVencimento: new Date('2024-10-20'),
        },
      ],
    },
    validacaoCredito: {
      aprovado: false,
      motivoReprovacao: 'Fornecedor com pendências fiscais e inadimplente',
      dataValidacao: new Date('2025-01-28'),
      validadoPor: 'Analista Fiscal',
    },
    estatisticas: {
      totalCompras: 32000.0,
      totalCreditoIBS: 32.0,
      totalCreditoCBS: 288.0,
      quantidadeNotas: 8,
    },
  },
  {
    id: 'f4',
    cnpj: '45.678.901/0001-23',
    razaoSocial: 'Fornecedor GHI S.A.',
    nomeFantasia: 'GHI Indústria',
    uf: 'RS',
    municipio: 'Porto Alegre',
    situacaoCadastral: 'SUSPENSA' as const,
    dataAbertura: new Date('2012-11-05'),
    regularidadeFiscal: {
      receitaFederal: {
        status: 'IRREGULAR' as const,
        dataConsulta: new Date('2025-01-28'),
        motivoIrregularidade: 'Omissão de declarações',
      },
      certidaoNegativa: {
        status: 'NAO_EMITIDA' as const,
      },
      fgts: {
        status: 'IRREGULAR' as const,
        dataConsulta: new Date('2025-01-28'),
      },
      trabalhista: {
        status: 'IRREGULAR' as const,
        dataConsulta: new Date('2025-01-28'),
      },
    },
    inadimplencia: {
      status: 'INADIMPLENTE' as const,
      valorTotal: 120000.0,
      quantidadeDebitos: 5,
      detalhes: [
        {
          tipo: 'ICMS',
          valor: 60000.0,
          dataVencimento: new Date('2024-09-30'),
        },
        {
          tipo: 'IPI',
          valor: 35000.0,
          dataVencimento: new Date('2024-10-15'),
        },
        {
          tipo: 'PIS/COFINS',
          valor: 20000.0,
          dataVencimento: new Date('2024-11-20'),
        },
        {
          tipo: 'FGTS',
          valor: 3000.0,
          dataVencimento: new Date('2024-08-10'),
        },
        {
          tipo: 'Trabalhista',
          valor: 2000.0,
          dataVencimento: new Date('2024-07-25'),
        },
      ],
    },
    validacaoCredito: {
      aprovado: false,
      motivoReprovacao: 'Situação cadastral suspensa e múltiplas irregularidades',
      dataValidacao: new Date('2025-01-28'),
      validadoPor: 'Analista Fiscal',
    },
    estatisticas: {
      totalCompras: 18000.0,
      totalCreditoIBS: 18.0,
      totalCreditoCBS: 162.0,
      quantidadeNotas: 4,
    },
  },
];

export const gestaoImpostosMock = {
  periodo: {
    inicio: new Date('2024-01-01'),
    fim: new Date('2025-01-31'),
  },
  historico: [
    {
      mes: 'Janeiro',
      ano: 2024,
      vendas: 1000000.0,
      icms: { valor: 180000.0, percentual: 18.0 },
      pis: { valor: 16500.0, percentual: 1.65 },
      cofins: { valor: 76000.0, percentual: 7.6 },
      ipi: { valor: 50000.0, percentual: 5.0 },
      ibs: { valor: 0, percentual: 0 },
      cbs: { valor: 0, percentual: 0 },
      totalImpostos: 322500.0,
      percentualTotal: 32.25,
    },
    {
      mes: 'Fevereiro',
      ano: 2024,
      vendas: 1050000.0,
      icms: { valor: 189000.0, percentual: 18.0 },
      pis: { valor: 17325.0, percentual: 1.65 },
      cofins: { valor: 79800.0, percentual: 7.6 },
      ipi: { valor: 52500.0, percentual: 5.0 },
      ibs: { valor: 0, percentual: 0 },
      cbs: { valor: 0, percentual: 0 },
      totalImpostos: 338625.0,
      percentualTotal: 32.25,
    },
    {
      mes: 'Março',
      ano: 2024,
      vendas: 980000.0,
      icms: { valor: 176400.0, percentual: 18.0 },
      pis: { valor: 16170.0, percentual: 1.65 },
      cofins: { valor: 74480.0, percentual: 7.6 },
      ipi: { valor: 49000.0, percentual: 5.0 },
      ibs: { valor: 0, percentual: 0 },
      cbs: { valor: 0, percentual: 0 },
      totalImpostos: 316050.0,
      percentualTotal: 32.25,
    },
    {
      mes: 'Abril',
      ano: 2024,
      vendas: 1100000.0,
      icms: { valor: 198000.0, percentual: 18.0 },
      pis: { valor: 18150.0, percentual: 1.65 },
      cofins: { valor: 83600.0, percentual: 7.6 },
      ipi: { valor: 55000.0, percentual: 5.0 },
      ibs: { valor: 0, percentual: 0 },
      cbs: { valor: 0, percentual: 0 },
      totalImpostos: 354750.0,
      percentualTotal: 32.25,
    },
    {
      mes: 'Maio',
      ano: 2024,
      vendas: 1150000.0,
      icms: { valor: 207000.0, percentual: 18.0 },
      pis: { valor: 18975.0, percentual: 1.65 },
      cofins: { valor: 87400.0, percentual: 7.6 },
      ipi: { valor: 57500.0, percentual: 5.0 },
      ibs: { valor: 0, percentual: 0 },
      cbs: { valor: 0, percentual: 0 },
      totalImpostos: 370875.0,
      percentualTotal: 32.25,
    },
    {
      mes: 'Junho',
      ano: 2024,
      vendas: 1080000.0,
      icms: { valor: 194400.0, percentual: 18.0 },
      pis: { valor: 17820.0, percentual: 1.65 },
      cofins: { valor: 82080.0, percentual: 7.6 },
      ipi: { valor: 54000.0, percentual: 5.0 },
      ibs: { valor: 0, percentual: 0 },
      cbs: { valor: 0, percentual: 0 },
      totalImpostos: 348300.0,
      percentualTotal: 32.25,
    },
  ],
  simulacaoTransicao: [
    {
      ano: 2026,
      percentualIBS: 0,
      percentualCBS: 0,
      icms: { valor: 180000.0, percentualReducao: 0 },
      pis: { valor: 16500.0, percentualReducao: 0 },
      cofins: { valor: 76000.0, percentualReducao: 0 },
      ibs: { valor: 0, percentualImplementacao: 0 },
      cbs: { valor: 0, percentualImplementacao: 0 },
      totalImpostos: 322500.0,
      percentualSobreVendas: 32.25,
      diferencaAnoAnterior: 0,
    },
    {
      ano: 2027,
      percentualIBS: 0,
      percentualCBS: 100,
      icms: { valor: 180000.0, percentualReducao: 0 },
      pis: { valor: 0, percentualReducao: 100 },
      cofins: { valor: 0, percentualReducao: 100 },
      ibs: { valor: 0, percentualImplementacao: 0 },
      cbs: { valor: 90000.0, percentualImplementacao: 100 },
      totalImpostos: 320000.0,
      percentualSobreVendas: 32.0,
      diferencaAnoAnterior: -2500.0,
    },
    {
      ano: 2029,
      percentualIBS: 10,
      percentualCBS: 100,
      icms: { valor: 162000.0, percentualReducao: 10 },
      pis: { valor: 0, percentualReducao: 100 },
      cofins: { valor: 0, percentualReducao: 100 },
      ibs: { valor: 1000.0, percentualImplementacao: 10 },
      cbs: { valor: 90000.0, percentualImplementacao: 100 },
      totalImpostos: 303000.0,
      percentualSobreVendas: 30.3,
      diferencaAnoAnterior: -17000.0,
    },
    {
      ano: 2030,
      percentualIBS: 20,
      percentualCBS: 100,
      icms: { valor: 144000.0, percentualReducao: 20 },
      pis: { valor: 0, percentualReducao: 100 },
      cofins: { valor: 0, percentualReducao: 100 },
      ibs: { valor: 2000.0, percentualImplementacao: 20 },
      cbs: { valor: 90000.0, percentualImplementacao: 100 },
      totalImpostos: 286000.0,
      percentualSobreVendas: 28.6,
      diferencaAnoAnterior: -17000.0,
    },
    {
      ano: 2031,
      percentualIBS: 30,
      percentualCBS: 100,
      icms: { valor: 126000.0, percentualReducao: 30 },
      pis: { valor: 0, percentualReducao: 100 },
      cofins: { valor: 0, percentualReducao: 100 },
      ibs: { valor: 3000.0, percentualImplementacao: 30 },
      cbs: { valor: 90000.0, percentualImplementacao: 100 },
      totalImpostos: 269000.0,
      percentualSobreVendas: 26.9,
      diferencaAnoAnterior: -17000.0,
    },
    {
      ano: 2032,
      percentualIBS: 40,
      percentualCBS: 100,
      icms: { valor: 108000.0, percentualReducao: 40 },
      pis: { valor: 0, percentualReducao: 100 },
      cofins: { valor: 0, percentualReducao: 100 },
      ibs: { valor: 4000.0, percentualImplementacao: 40 },
      cbs: { valor: 90000.0, percentualImplementacao: 100 },
      totalImpostos: 252000.0,
      percentualSobreVendas: 25.2,
      diferencaAnoAnterior: -17000.0,
    },
    {
      ano: 2033,
      percentualIBS: 100,
      percentualCBS: 100,
      icms: { valor: 0, percentualReducao: 100 },
      pis: { valor: 0, percentualReducao: 100 },
      cofins: { valor: 0, percentualReducao: 100 },
      ibs: { valor: 10000.0, percentualImplementacao: 100 },
      cbs: { valor: 90000.0, percentualImplementacao: 100 },
      totalImpostos: 150000.0,
      percentualSobreVendas: 15.0,
      diferencaAnoAnterior: -102000.0,
    },
  ],
  resumoAtual: {
    totalVendas: 1000000.0,
    totalImpostos: 322500.0,
    percentualTotal: 32.25,
    detalhamento: {
      icms: { valor: 180000.0, percentual: 18.0 },
      pis: { valor: 16500.0, percentual: 1.65 },
      cofins: { valor: 76000.0, percentual: 7.6 },
      ipi: { valor: 50000.0, percentual: 5.0 },
      ibs: { valor: 0, percentual: 0 },
      cbs: { valor: 0, percentual: 0 },
    },
  },
};
